"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _styledSystem = require("styled-system");

var _ = require("..");

var _Modal = require("./Modal.style");

var _excluded = ["bg", "children", "className", "dialogAnimation", "disableCloseButton", "enableOverflow", "fullScreen", "height", "isOpen", "onClose", "overlayAnimation", "timeout", "verticalAlignment", "width", "zIndex", "transitionDirection", "onOverlayClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Modal = function Modal(_ref) {
  var bg = _ref.bg,
      children = _ref.children,
      className = _ref.className,
      dialogAnimation = _ref.dialogAnimation,
      disableCloseButton = _ref.disableCloseButton,
      enableOverflow = _ref.enableOverflow,
      fullScreen = _ref.fullScreen,
      height = _ref.height,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      overlayAnimation = _ref.overlayAnimation,
      timeout = _ref.timeout,
      verticalAlignment = _ref.verticalAlignment,
      width = _ref.width,
      zIndex = _ref.zIndex,
      transitionDirection = _ref.transitionDirection,
      onOverlayClick = _ref.onOverlayClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var dialogHeight = height;

  if (enableOverflow) {
    dialogHeight = null;
  } else if (fullScreen) {
    dialogHeight = 1;
  }

  var transitionD = dialogAnimation;

  if (transitionDirection && transitionDirection.toLowerCase() === 'up') {
    transitionD = _Modal.transitionUp;
  } else if (transitionDirection && transitionDirection.toLowerCase() === 'down') {
    transitionD = _Modal.transitionDown;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    "in": isOpen,
    unmountOnExit: true,
    timeout: timeout
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement(_Modal.Overlay, {
      onDismiss: typeof onOverlayClick === 'function' ? onOverlayClick : onClose,
      zindex: zIndex,
      transitionstate: state,
      initialFocusRef: null,
      defaultAnimation: _Modal.OVERLAY_ANIMATION,
      customAnimation: overlayAnimation,
      enableoverflow: enableOverflow
    }, /*#__PURE__*/_react["default"].createElement(_Modal.OverlayWrapper, null, /*#__PURE__*/_react["default"].createElement(_Modal.DialogWrapper, {
      enableoverflow: enableOverflow,
      verticalAlignment: verticalAlignment
    }, /*#__PURE__*/_react["default"].createElement(_Modal.Dialog, (0, _extends2["default"])({
      width: fullScreen ? 1 : width,
      bg: bg,
      height: dialogHeight,
      transitionstate: state,
      className: className,
      enableoverflow: enableOverflow ? 'true' : null,
      defaultAnimation: _Modal.DIALOG_ANIMATION,
      customAnimation: transitionD,
      fullScreen: fullScreen,
      "data-testid": "dialog-content"
    }, props), /*#__PURE__*/_react["default"].createElement(_Modal.DialogInnerWrapper, {
      flexDirection: "column",
      className: "d-inner-wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_Modal.ContentWrapper, {
      enableoverflow: enableOverflow
    }, !disableCloseButton && /*#__PURE__*/_react["default"].createElement(_.IconButton, {
      variant: "plain",
      color: "primary",
      size: 32,
      onClick: onClose,
      className: "eui-modal-close"
    }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
      iconName: "Close",
      size: 18
    })), children))))));
  });
};

Modal.defaultProps = {
  bg: 'white',
  dialogAnimation: null,
  disableCloseButton: true,
  enableOverflow: false,
  isOpen: false,
  overlayAnimation: null,
  timeout: 500,
  verticalAlignment: 'middle',
  zIndex: 1300,
  size: 'sm',
  padding: true
};
Modal.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _styledSystem.width.propTypes), _styledSystem.height.propTypes), {}, {
  className: _propTypes["default"].string,
  dialogAnimation: _propTypes["default"].func,
  disableCloseButton: _propTypes["default"].bool,
  enableOverflow: _propTypes["default"].bool,
  fullScreen: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onOverlayClick: _propTypes["default"].func,
  overlayAnimation: _propTypes["default"].func,
  timeout: _propTypes["default"].number,
  title: _propTypes["default"].string,
  verticalAlignment: _propTypes["default"].string,
  zIndex: _propTypes["default"].number,
  bg: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
  padding: _propTypes["default"].bool
});
var _default = Modal;
exports["default"] = _default;